import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FeatureName = ({
  featureDisplayName,
  isBeta,
  showBetaBadge = true,
  textStyles
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    as: "span",
    display: "inline-flex",
    alignItems: "center",
    gap: "100",
    flexWrap: "wrap",
    children: [/*#__PURE__*/_jsx(Text, Object.assign({}, textStyles, {
      children: featureDisplayName
    })), isBeta && showBetaBadge && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "feature-monetization.featureTable.beta"
    })]
  });
};